import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * Cliente del módulo TRM USD/PEN del backend NestJS (`trmpen`).
 * Espejo de `RailColombiaService`: misma forma de respuesta, otra base.
 * El token (idToken Cognito) lo agrega automáticamente ApiRestInterceptor.
 */
@Injectable({
  providedIn: 'root',
})
export class RailPeruService {
  private readonly API_NEST = environment.apiNest;

  constructor(private http: HttpClient) {}

  /** Última tasa de mercado (Investing). Fila única. */
  getLatest(): Promise<any> {
    return firstValueFrom(this.http.get<any>(`${this.API_NEST}trmpen`));
  }

  /**
   * Última tasa de CADA fuente: `{ WISE, INVESTING, VITA_PUBLIC }`.
   * WISE = mercado de referencia vigente; INVESTING = serie histórica (sin
   * datos desde 2026-07-16, no se llega al sitio desde prod);
   * VITA_PUBLIC = tasa pública de Vita.
   */
  getLatestAll(): Promise<{ WISE: any | null; INVESTING: any | null; VITA_PUBLIC: any | null }> {
    return firstValueFrom(
      this.http.get<{ WISE: any | null; INVESTING: any | null; VITA_PUBLIC: any | null }>(
        `${this.API_NEST}trmpen/all`,
      ),
    );
  }

  /** Historial (array) opcionalmente limitado y filtrado por fuente. */
  getHistory(limit = 100, fuente?: string): Promise<any[]> {
    const f = fuente ? `&fuente=${encodeURIComponent(fuente)}` : '';
    return firstValueFrom(
      this.http.get<any[]>(
        `${this.API_NEST}trmpen/historial?limit=${limit}${f}`,
      ),
    );
  }

  /** Fuerza una consulta inmediata. Devuelve { ok, guardado }. */
  forceRefresh(): Promise<any> {
    return firstValueFrom(
      this.http.post<any>(`${this.API_NEST}trmpen/refresh`, {}),
    );
  }
}
